import { render, staticRenderFns } from "./SKUSDataTable.vue?vue&type=template&id=c3b264a8"
import script from "./SKUSDataTable.vue?vue&type=script&lang=js"
export * from "./SKUSDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports